<template>
    <div class="container">
        <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false" class="company-dialog">
            <md-dialog-title class="dialog-header">
                <span class="header-title">{{ labels.newCompany }}</span>
            </md-dialog-title>

            <md-dialog-content class="dialog-content">
                <div class="form-container">
                    <b-row>
                        <b-col md="12">
                            <div class="form-group-custom">
                                <label class="label-custom">{{ labels.name }} <span class="required">*</span></label>
                                <md-field class="custom-field" :class="{ 'md-invalid': errors.name }">
                                    <md-input
                                        type="text"
                                        name="name"
                                        v-model="form.name"
                                        :placeholder="labels.name"
                                        @blur="validateField('name')"
                                    />
                                    <span class="error-message" v-if="errors.name">{{ errors.name }}</span>
                                </md-field>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                            <div class="form-group-custom">
                                <label class="label-custom">{{ labels.currency }} <span class="required">*</span></label>
                                <md-field class="custom-field" :class="{ 'md-invalid': errors.idCurrency }">
                                    <md-select 
                                        name="currency" 
                                        v-model="form.idCurrency" 
                                        placeholder="Seleccione..."
                                        @blur="validateField('idCurrency')"
                                    >
                                        <md-option :key="currency.id" :value="currency.id" v-for="currency in listCurrency">
                                            {{ currency.nombre }}
                                        </md-option>
                                    </md-select>
                                    <span class="error-message" v-if="errors.idCurrency">{{ errors.idCurrency }}</span>
                                </md-field>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                            <div class="form-group-custom">
                                <label class="label-custom">{{ labels.acronym }} <span class="required">*</span></label>
                                <md-field class="custom-field" :class="{ 'md-invalid': errors.acronym }">
                                    <md-input
                                        type="text"
                                        name="acronym"
                                        v-model="form.acronym"
                                        :placeholder="labels.acronym"
                                        @blur="validateField('acronym')"
                                    />
                                    <span class="error-message" v-if="errors.acronym">{{ errors.acronym }}</span>
                                </md-field>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                            <div class="form-group-custom">
                                <label class="label-custom">{{ labels.code }}</label>
                                <md-field class="custom-field">
                                    <md-input
                                        type="text"
                                        name="code"
                                        v-model="form.code"
                                        :placeholder="labels.code"
                                    />
                                </md-field>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                            <div class="form-group-custom">
                                <label class="label-custom">{{ labels.identificacion }} <span class="required">*</span></label>
                                <md-field class="custom-field" :class="{ 'md-invalid': errors.identificacion }">
                                    <md-input
                                        type="text"
                                        name="identificacion"
                                        v-model="form.identificacion"
                                        :placeholder="labels.identificacion"
                                        @blur="validateField('identificacion')"
                                    />
                                    <span class="error-message" v-if="errors.identificacion">{{ errors.identificacion }}</span>
                                </md-field>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                            <div class="form-group-custom">
                                <label class="label-custom">{{ labels.grupo }} <span class="required">*</span></label>
                                <md-field class="custom-field" :class="{ 'md-invalid': errors.id_grupos }">
                                    <md-select 
                                        name="grupo" 
                                        v-model="form.id_grupos" 
                                        placeholder="Seleccione un grupo..."
                                        @blur="validateField('id_grupos')"
                                    >
                                        <md-option :key="grupo.id" :value="grupo.id" v-for="grupo in listGrupos">
                                            {{ grupo.nombre }}
                                        </md-option>
                                    </md-select>
                                    <span class="error-message" v-if="errors.id_grupos">{{ errors.id_grupos }}</span>
                                </md-field>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </md-dialog-content>

            <md-dialog-actions class="dialog-actions">
                <div class="actions-right">
                    <md-button class="md-raised cancel-btn" @click="clicked">
                        {{ labels.close }}
                    </md-button>
                    <md-button class="md-raised md-primary save-btn" @click="saveCompany">
                        {{ labels.save }}
                    </md-button>
                </div>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
    import Company from "@/services/Company"
    import Currency from "@/services/Currency"
    import Grupo from "@/services/Grupo"

    export default {
        name: "NewCompany",
        props: ['showDialog'],

        data: () => ({
            form: {
                name: "",
                idCurrency: "",
                acronym: "",
                code: "",
                identificacion: "",
                id_grupos: ""
            },
            listCurrency: [],
            listGrupos: [],
            errors: {
                name: "",
                idCurrency: "",
                acronym: "",
                code: "",
                identificacion: "",
                id_grupos: ""
            }
        }),

        watch: {
            showDialog(val) {
                if (val) {
                    this.resetForm();
                    this.loadData();
                }
            }
        },

        computed: {
            labels() {
                if (this.$store.state._language == "es-ES") {
                    return {
                        newCompany: "Nueva Compañía",
                        name: "Nombre",
                        currency: "Moneda",
                        acronym: "Acrónimo",
                        code: "Código",
                        identificacion: "NIT",
                        grupo: "Grupo",
                        save: "Guardar",
                        close: "Cerrar"
                    }
                } else {
                    return {
                        newCompany: "New Company",
                        name: "Name",
                        currency: "Currency",
                        acronym: "Acronym",
                        code: "Code",
                        identificacion: "Tax ID",
                        grupo: "Group",
                        save: "Save",
                        close: "Close"
                    }
                }
            }
        },

        methods: {
            resetForm() {
                this.form = {
                    name: "",
                    idCurrency: "",
                    acronym: "",
                    code: "",
                    identificacion: "",
                    id_grupos: ""
                };
                this.errors = {
                    name: "",
                    idCurrency: "",
                    acronym: "",
                    code: "",
                    identificacion: "",
                    id_grupos: ""
                };
            },

            validateField(field) {
                const lang = this.$store.state._language;
                
                switch(field) {
                    case 'name':
                        if (!this.form.name) {
                            this.errors.name = lang == "es-ES" ? "El nombre es obligatorio" : "Name is required";
                        } else if (this.form.name.length < 3) {
                            this.errors.name = lang == "es-ES" ? "El nombre debe tener al menos 3 caracteres" : "Name must have at least 3 characters";
                        } else {
                            this.errors.name = "";
                        }
                        break;
                    
                    case 'idCurrency':
                        if (!this.form.idCurrency) {
                            this.errors.idCurrency = lang == "es-ES" ? "Debe seleccionar una moneda" : "Please select a currency";
                        } else {
                            this.errors.idCurrency = "";
                        }
                        break;
                    
                    case 'acronym':
                        if (!this.form.acronym) {
                            this.errors.acronym = lang == "es-ES" ? "El acrónimo es obligatorio" : "Acronym is required";
                        } else if (this.form.acronym.length < 2) {
                            this.errors.acronym = lang == "es-ES" ? "El acrónimo debe tener al menos 2 caracteres" : "Acronym must have at least 2 characters";
                        } else {
                            this.errors.acronym = "";
                        }
                        break;
                    
                    case 'identificacion':
                        if (!this.form.identificacion) {
                            this.errors.identificacion = lang == "es-ES" ? "El NIT es obligatorio" : "Tax ID is required";
                        } else if (!/^\d{1,20}$/.test(this.form.identificacion)) {
                            this.errors.identificacion = lang == "es-ES" ? "El NIT solo debe contener números" : "Tax ID must contain only numbers";
                        } else {
                            this.errors.identificacion = "";
                        }
                        break;
                    
                    case 'id_grupos':
                        if (!this.form.id_grupos) {
                            this.errors.id_grupos = lang == "es-ES" ? "Debe seleccionar un grupo" : "Please select a group";
                        } else {
                            this.errors.id_grupos = "";
                        }
                        break;
                }
            },

            validateForm() {
                this.validateField('name');
                this.validateField('idCurrency');
                this.validateField('acronym');
                this.validateField('identificacion');
                this.validateField('id_grupos');
                
                return !this.errors.name && 
                       !this.errors.idCurrency && 
                       !this.errors.acronym && 
                       !this.errors.identificacion && 
                       !this.errors.id_grupos;
            },

            clicked() {
                this.$emit('clicked', false);
            },

            async saveCompany() {
                if (!this.validateForm()) {
                    this.$toast.error(this.$store.state._language == "es-ES" 
                        ? "Por favor, corrija los errores del formulario" 
                        : "Please correct the form errors");
                    return;
                }

                try {
                    const companyData = {
                        name: this.form.name,
                        idCurrency: this.form.idCurrency,
                        acronym: this.form.acronym,
                        code: this.form.code || null,
                        identificacion: this.form.identificacion,
                        id_grupos: this.form.id_grupos,
                        userId: this.$store.state.userId,
                        estado: 1
                    };

                    const result = await Company.createCompany(companyData);
                    
                    this.$toast.success(result.data.message || (this.$store.state._language == "es-ES" 
                        ? "Compañía creada exitosamente" 
                        : "Company created successfully"));
                    
                    this.$emit('companyCreated', true);
                    this.clicked();
                } catch (error) {
                    console.error("Error creating company:", error);
                    
                    let errorMessage = this.$store.state._language == "es-ES" 
                        ? "Error al crear la compañía" 
                        : "Error creating company";
                    
                    if (error.response && error.response.data) {
                        if (error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.data.error) {
                            errorMessage = error.response.data.error;
                        }
                    }
                    
                    this.$toast.error(errorMessage);
                }
            },

            async loadData() {
                try {
                    const [currencyRes, grupoRes] = await Promise.all([
                        Currency.getAllCurrency(),
                        Grupo.getAllGrupos()
                    ]);
                    
                    this.listCurrency = currencyRes.data.currency || [];
                    this.listGrupos = grupoRes.data.grupos || [];
                } catch (error) {
                    console.error("Error loading data:", error);
                    this.$toast.error(this.$store.state._language == "es-ES" 
                        ? "Error al cargar los datos" 
                        : "Error loading data");
                }
            }
        },

        mounted() {
            this.loadData();
        }
    }
</script>

<style scoped>
.company-dialog >>> .md-dialog {
    max-width: 600px;
    width: 90%;
    border-radius: 8px;
    overflow: hidden;
}

.dialog-header {
    background: #34495e;
    color: white;
    padding: 20px 24px;
    margin: 0;
    border-bottom: 1px solid #2c3e50;
}

.header-title {
    font-size: 1.3rem;
    font-weight: 500;
}

.dialog-content {
    padding: 20px 24px;
    max-height: 70vh;
    overflow-y: auto;
}

.form-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.form-group-custom {
    margin-bottom: 0;
}

.label-custom {
    display: block;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 8px;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.required {
    color: #e74c3c;
}

.custom-field {
    margin: 0;
}

.md-field.md-invalid .md-input,
.md-field.md-invalid .md-select {
    border-color: #ff5252;
}

.error-message {
    color: #ff5252;
    font-size: 12px;
    margin-top: 4px;
    display: block;
}

.dialog-actions {
    padding: 20px 24px;
    border-top: 1px solid #ecf0f1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #f8f9fa;
}

.actions-right {
    display: flex;
    gap: 12px;
}

.cancel-btn {
    background: #95a5a6 !important;
    color: white !important;
    font-size: 14px;
    padding: 10px 24px;
    min-width: 100px;
}

.save-btn {
    background: #3498db !important;
    color: white !important;
    font-size: 14px;
    padding: 10px 24px;
    min-width: 100px;
}

.cancel-btn:hover {
    background: #7f8c8d !important;
}

.save-btn:hover {
    background: #2980b9 !important;
}

/* Scroll personalizado */
.dialog-content::-webkit-scrollbar {
    width: 8px;
}

.dialog-content::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.dialog-content::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
}

.dialog-content::-webkit-scrollbar-thumb:hover {
    background: #555;
}

/* Responsive */
@media (max-width: 768px) {
    .company-dialog >>> .md-dialog {
        width: 95%;
        margin: 16px;
    }
    
    .actions-right {
        width: 100%;
        flex-direction: column;
    }
    
    .cancel-btn, .save-btn {
        width: 100%;
        margin: 4px 0;
    }
}
</style>